import { jsx as _jsx } from "react/jsx-runtime";
import { FullLoading } from "../../../../components/Loading/Loading";
function LoadingPage() {
    return _jsx(FullLoading, {});
}
export { LoadingPage };
